import I18n from 'I18n';
import { useState } from 'react';
import styled, { css } from 'styled-components';
import { getFocusRingStyles } from 'visitor-ui-component-library/utils/getFocusRingStyles';
import GalleryThumbnail from './GalleryThumbnail';

/** Maximum images shown before the "+N more" overflow cell and "Show all" CTA appear. */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const COMPACT_ITEM_LIMIT = 4;
const GalleryContainer = styled.div.withConfig({
  displayName: "MediaGallery__GalleryContainer"
})(["max-width:360px;margin-bottom:", ";"], ({
  theme
}) => theme.spotlight.spacing.sm);
const GalleryGrid = styled.div.withConfig({
  displayName: "MediaGallery__GalleryGrid"
})(["display:grid;grid-template-columns:1fr 1fr;gap:", ";border-radius:", ";overflow:hidden;", ""], ({
  theme
}) => theme.spotlight.spacing.xs, ({
  theme
}) => theme.spotlight.borderRadius.sm, ({
  $itemCount
}) => $itemCount === 3 && css(["& >:first-child{grid-column:span 2;aspect-ratio:2 / 1;}"]));
const ShowToggleButton = styled.button.withConfig({
  displayName: "MediaGallery__ShowToggleButton"
})(["display:block;width:100%;background:none;border:none;padding:", " 0 0;margin-bottom:", ";cursor:pointer;color:", ";font-size:", ";text-align:left;&:hover{text-decoration:underline;}", ""], ({
  theme
}) => theme.spotlight.spacing.sm, ({
  theme
}) => theme.spotlight.spacing.sm, ({
  theme
}) => theme.spotlight.color.muted, ({
  theme
}) => theme.spotlight.typography.fontSize.md, ({
  theme
}) => getFocusRingStyles({
  outlineOffset: theme.spotlight.spacing.xs
}));
const MediaGallery = ({
  items,
  onImagePress
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const visibleItems = isExpanded ? items : items.slice(0, COMPACT_ITEM_LIMIT);
  const hiddenCount = !isExpanded && items.length > COMPACT_ITEM_LIMIT ? items.length - COMPACT_ITEM_LIMIT : 0;
  return /*#__PURE__*/_jsxs(GalleryContainer, {
    children: [/*#__PURE__*/_jsx(GalleryGrid, {
      $itemCount: items.length,
      children: visibleItems.map((item, index) => {
        const isLastVisible = index === visibleItems.length - 1;
        const isOverflowCell = hiddenCount > 0 && isLastVisible;
        const handlePress = !isOverflowCell && onImagePress ? () => onImagePress(index) : undefined;
        const handleExpand = isOverflowCell ? () => setIsExpanded(true) : undefined;
        return /*#__PURE__*/_jsx(GalleryThumbnail, {
          item: item,
          hiddenCount: isLastVisible ? hiddenCount : 0,
          totalCount: isOverflowCell ? items.length : undefined,
          onPress: handlePress,
          onExpand: handleExpand
        }, item.fileMetadata.url);
      })
    }), items.length > COMPACT_ITEM_LIMIT && /*#__PURE__*/_jsx(ShowToggleButton, {
      type: "button",
      "aria-expanded": isExpanded,
      onClick: () => setIsExpanded(!isExpanded),
      children: isExpanded ? I18n.text('conversations-visitor-ui.spotlight.mediaGallery.showLess') : I18n.text('conversations-visitor-ui.spotlight.mediaGallery.showAll', {
        count: items.length
      })
    })]
  });
};
MediaGallery.displayName = 'MediaGallery';
export default MediaGallery;